var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _c("span", { staticStyle: { position: "absolute", left: "20px" } }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _c(
      "div",
      { staticStyle: { float: "right", "padding-right": "5px" } },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", disabled: !_vm.isEdit },
            on: { click: _vm.addCommerceResponsiblePersonHandler }
          },
          [
            _vm._v(
              _vm._s(
                "+" +
                  _vm.$t("CargoMsg.Cargo_add") +
                  _vm.$t("SeaExport.ResponsiblePerson")
              )
            )
          ]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "section grid-wrapper", staticStyle: { height: "250px" } },
      [
        _c("cargo-ag-grid", {
          staticStyle: { width: "100%" },
          attrs: {
            "grid-options": _vm.gridOptions,
            "column-defs": _vm.columnDefs,
            "row-data": _vm.rowData
          },
          on: {
            gridReady: function(params) {
              _vm.gridApi = params.api
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }